/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type SettingManagementListSettingRequest = {
    word?: string | null;
    perPage?: number | null;
    page?: number | null;
    keyword?: string | null;
    sort?: string | null;
    direction?: SettingManagementListSettingRequest.direction | null;
    categories?: Array<string> | null;
};

export namespace SettingManagementListSettingRequest {

    export enum direction {
        ASC = 'asc',
        DESC = 'desc',
    }


}

